import { useEffect, useRef, useState } from 'react';
import { animate } from 'framer-motion';

const ANIMATION_DURATION_SECONDS = 1.2;

/** Counts from 0 up to `targetValue` on mount/change; calls `onComplete` once it lands. */
export function useAnimatedGaugeValue(targetValue, onComplete) {
  const [animatedValue, setAnimatedValue] = useState(0);
  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;

  useEffect(() => {
    const controls = animate(0, targetValue, {
      duration: ANIMATION_DURATION_SECONDS,
      ease: 'easeOut',
      onUpdate: setAnimatedValue,
      onComplete: () => onCompleteRef.current?.(),
    });
    return () => controls.stop();
  }, [targetValue]);

  return animatedValue;
}
